import React, { useRef, useEffect, useImperativeHandle, forwardRef } from 'react';
import SignaturePadLib from 'signature_pad';

export interface SignaturePadHandle {
  toDataURL: () => string;
  isEmpty: () => boolean;
  clear: () => void;
}

interface SignaturePadProps {
  width?: number;
  height?: number;
}

const SignaturePad = forwardRef<SignaturePadHandle, SignaturePadProps>(
  ({ width = 400, height = 200 }, ref) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const padRef = useRef<SignaturePadLib | null>(null);

    useEffect(() => {
      if (canvasRef.current) {
        padRef.current = new SignaturePadLib(canvasRef.current, {
          backgroundColor: 'rgb(255, 255, 255)',
        });
      }
      return () => { padRef.current?.off(); };
    }, []);

    useImperativeHandle(ref, () => ({
      toDataURL: () => padRef.current?.toDataURL('image/png') || '',
      isEmpty: () => padRef.current?.isEmpty() ?? true,
      clear: () => padRef.current?.clear(),
    }));

    return (
      <canvas
        ref={canvasRef}
        width={width}
        height={height}
        style={{
          border: '1px solid #E0E0E0',
          borderRadius: 8,
          touchAction: 'none',
          width: '100%',
          height: `${height}px`,
        }}
      />
    );
  }
);

SignaturePad.displayName = 'SignaturePad';
export default SignaturePad;
